<div class="inner-page-header">
  <h3>{{ title }}</h3>
</div>

@if (isLoading) {
  <app-spinner></app-spinner>
}

<div class="request-details-wrapper">
  <form
    class="needs-validation"
    [formGroup]="requestFormGroup"
    (ngSubmit)="onSubmit()"
  >
    <!-- Request Information Section -->
    <div class="info-section">
      <div class="section-header">
        <h3>معلومات مقدم الطلب</h3>
      </div>
      <div class="section-content">
        <div class="info-grid">
          <!-- Row 1 -->
          <div class="info-item">
            <label class="info-label">اسم الفاحص</label>
            <div class="info-value with-icons">
              <p>
                <a
                  [href]="
                    '/pages/customers/customer-profile/' +
                    requestData?.application_id
                  "
                  target="_blank"
                  class="client-name-link"
                >
                  {{ requestData?.expert.full_name || "-" }}
                </a>
                <span class="custom-tooltip">
                  <img src="assets/images/svg/phone-tooltip.svg" alt="" />
                  <span
                    dir="ltr"
                    class="tooltip-text clickable"
                    (click)="copyClientMobile()"
                  >
                    {{ requestData?.expert.mobile || "-" }}
                    <img
                      src="assets/images/svg/copy-report-link.svg"
                      alt="copy"
                      style="
                        width: 14px;
                        height: 14px;
                        margin-left: 4px;
                        cursor: pointer;
                      "
                    />
                  </span>
                </span>
                <span class="custom-tooltip">
                  <img src="assets/images/svg/email-tooltip.svg" alt="" />
                  <span class="tooltip-text">{{
                    requestData?.expert.email || "-"
                  }}</span>
                </span>
              </p>
            </div>
          </div>
          <div class="info-item">
            <label class="info-label">التخصص</label>
            @for (
              item of requestData?.expert.expert_focus_areas;
              track $index
            ) {
              <div class="info-value">
                {{ item }}
              </div>
            }
          </div>
          <div class="info-item">
            <label class="info-label">تاريخ الإنضمام</label>
            <div class="info-value">
              {{ formatDate(requestData?.created_at) }}
            </div>
          </div>

          <div class="info-item">
            <label class="info-label">التقييم العام</label>
            <div class="info-value">
              {{ requestData?.expert.overall_rating }}
            </div>
          </div>

          <!-- Row 2 -->
          <div class="info-item full-width">
            <label class="info-label">الخدمات الحالية</label>
            <div class="services-list">
              @if (requestData?.expert.services?.length === 0) {
                <div class="service-item">-</div>
              } @else {
                @for (item of requestData?.expert.services; track $index) {
                  <div class="service-item">{{ item }}</div>
                }
              }
            </div>
          </div>
          <div class="info-item">
            <label class="info-label">عدد الطلبات</label>
            <div class="info-value">
              {{ requestData?.expert.orders_count || "-" }}
            </div>
          </div>

          <div class="info-item">
            <label class="info-label">المدينة</label>
            <div class="info-value">
              {{ requestData?.expert.primary_covered_city.name }}
            </div>
          </div>

          <div class="info-item">
            <label class="info-label">المنطقة</label>
            <div class="info-value">
              {{ requestData?.expert.primary_covered_region.name }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Service Details Section -->
    <div class="info-section">
      <div class="section-header">
        <h3>تفاصيل الخدمة</h3>
      </div>
      <div class="section-content">
        <div class="service-details-container">
          <!-- Top Info Row -->
          <div class="top-info-row">
            <div class="info-field">
              <label class="field-label">تاريخ طلب الخدمة</label>
              <div class="field-value">
                {{ formatDate(requestData?.created_at) }}
              </div>
            </div>
            <div class="info-field">
              <label class="field-label">اسم الخدمة</label>
              <div class="field-value">
                {{ requestData?.classification?.name || "-" }}
              </div>
            </div>
          </div>

          <!-- Document Rows -->
          @if (requestData?.file_uploads?.length > 0) {
            @for (doc of requestData.file_uploads; track doc.id) {
              <div class="document-row">
                <div class="doc-right">
                  <label class="field-label">{{
                    doc.required_file_name
                  }}</label>
                  <a
                    [href]="doc.uploaded_file"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn btn-attachment"
                  >
                    <img
                      src="assets/images/svg/doc-icon.svg"
                      alt="Attachment Icon"
                      class="attachment-icon"
                    />
                    <span>الملف المرفق</span>
                  </a>
                </div>
                <div class="doc-left">
                  @if (doc.uploaded_file_expiry_date) {
                    <label class="field-label">تاريخ الانتهاء</label>
                    <div class="date-input">
                      <input
                        type="text"
                        [value]="formatDate(doc.uploaded_file_expiry_date)"
                        readonly
                        class="form-control-static"
                      />
                    </div>
                  }
                </div>
              </div>
            }
          }

          <!-- Action Buttons inside Service Details -->
          @if (
            requestData?.status !== ApplicationStatus.ACCEPTED &&
            requestData?.status !== ApplicationStatus.REJECTED
          ) {
            <div class="service-action-buttons">
              <button type="submit" class="btn btn-green">الموافقة</button>
              <button
                type="button"
                class="btn btn-delete"
                (click)="rejectRequest()"
              >
                رفض الطلب
              </button>
              <button
                type="button"
                class="btn btn-confirm"
                (click)="requestModification()"
              >
                طلب تعديل
              </button>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Contract History Section -->
    @if (requestData?.notes) {
      <div class="info-section">
        <div class="section-header">
          <h3>سجل النقاش</h3>
        </div>
        <div class="section-content">
          <div class="history-list">
            <p class="font-regular">سجل الرسائل مع الخبير</p>
            <div class="history-item">
              <div
                class="history-text"
                [innerHTML]="requestData?.notes || '-'"
              ></div>
              <div class="history-date">
                {{ formatDate(requestData?.updated_at) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </form>
</div>
